import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-184d4d69")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PopUpSection = _resolveComponent("PopUpSection")

  return (_openBlock(), _createBlock("div", {
    class: "panel",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.naviateToLP(_ctx.webinar.landing_page_url))),
    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onmouseenter())),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onmouseout()))
  }, [
    _createVNode("div", {
      class: "poster-image",
      style: `background-image:url(${_ctx.webinar.poster_url}) !important`
    }, null, 4),
    _createVNode("span", {
      class: "title",
      innerHTML: _ctx.webinar.title
    }, null, 8, ["innerHTML"]),
    _createVNode(_component_PopUpSection, {
      webinar: _ctx.webinar,
      shouldLoad: _ctx.shouldLoad,
      hovering: _ctx.getHovering()
    }, null, 8, ["webinar", "shouldLoad", "hovering"])
  ], 32))
})